import React from 'react'

import { CardContent } from '@material-ui/core'

const Body = ({ children }) => {
  return <CardContent>{children}</CardContent>
}

export default Body
